import { type InfiniteData } from '@tanstack/react-query';

import { type TGetInfiniteSearchResultDesktopResponse_1 } from '@/repositories/generated/shared/search-offers/v2/get-infinite-search-result-desktop';

type PageAndOfferIndexForInfiniteData = {
  offerIndex: number | null;
  pageIndex: number | null;
};

export const getPageAndOfferIndexForInfiniteData = (
  data: InfiniteData<TGetInfiniteSearchResultDesktopResponse_1>,
  entityId: number,
): PageAndOfferIndexForInfiniteData => {
  const indexMap: PageAndOfferIndexForInfiniteData = {
    offerIndex: null,
    pageIndex: null,
  };

  let isResolved = false;

  for (let pageIndex = 0; pageIndex < data.pages.length; pageIndex++) {
    /**
     * Просто прерываем цикл, нет смысла покрывать
     */
    /* istanbul ignore next */
    if (isResolved) {
      break;
    }

    const page = data.pages[pageIndex];

    for (let offerIndex = 0; offerIndex < page.offers.length; offerIndex++) {
      if (page.offers[offerIndex].id === entityId) {
        indexMap.pageIndex = pageIndex;
        indexMap.offerIndex = offerIndex;
        isResolved = true;

        break;
      }
    }
  }

  return indexMap;
};
